import { mdy, dollars, tsvText } from './shared';

// QuickBooks Desktop IIF: one GENERAL JOURNAL transaction per entry.
//   !TRNS / !SPL header rows, then TRNS (first line), SPL (every other line),
//   ENDTRNS. Debits are positive, credits negative, and every transaction
//   must sum to zero — the Over/short line guarantees that, and we assert it
//   rather than hand QuickBooks a file it will reject half-way through.
// ACCNT must match the Desktop chart of accounts exactly (sub-accounts as
// Parent:Child); unknown names are silently created on import, which is why
// the page blocks this export while any tender is unmapped.
const HEADER = ['TRNSID', 'TRNSTYPE', 'DATE', 'ACCNT', 'NAME', 'CLASS', 'AMOUNT', 'DOCNUM', 'MEMO'];

const signed = (line) => (line.side === 'debit' ? line.amount : -line.amount);

export function buildJournalIif(entries) {
  const rows = [
    ['!TRNS', ...HEADER],
    ['!SPL', ...HEADER.map(h => (h === 'TRNSID' ? 'SPLID' : h))],
    ['!ENDTRNS'],
  ];
  for (const e of entries) {
    const lines = (e.lines || []).filter(l => l.amount !== 0);
    if (lines.length === 0) continue;
    const total = lines.reduce((a, l) => a + signed(l), 0);
    if (total !== 0) throw new Error(`Journal ${e.docNum} does not balance (${dollars(total)})`);
    const date = mdy(e.periodEnd);
    lines.forEach((l, i) => {
      rows.push([
        i === 0 ? 'TRNS' : 'SPL', '', 'GENERAL JOURNAL', date, l.account, '', e.class || '',
        dollars(signed(l)), e.docNum, i === 0 ? e.memo : l.label,
      ]);
    });
    rows.push(['ENDTRNS']);
  }
  return tsvText(rows);
}
